
import React, { useEffect, useState, useRef } from "react";
import { styled, useTheme, alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Monitor, Shield, FileText, Mail } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import Topnavbar from "./Topnavbar";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import "./nav.scss";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { Drawer as MuiDrawer } from "@mui/material/";
import aays from "../assets/img/AaysLogo.png";

const SIDEBAR_STORAGE_KEY = 'sidebarOpen';

const SideNavbar = () => {
  // Initialize sidebar state from sessionStorage
  const [open, setOpen] = useState(() => {
    const savedState = sessionStorage.getItem(SIDEBAR_STORAGE_KEY);
    return savedState === 'true';
  });

  const [openDialog, setOpenDialog] = useState(false);
  const [bgColor] = useState("white");
  const drawerWidth = 300;
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // Restore sidebar state after navigation
  useEffect(() => {
    const savedState = sessionStorage.getItem(SIDEBAR_STORAGE_KEY);
    if (savedState === 'true') {
      setOpen(true);
    }
  }, [pathname]);

  const toggleDrawer = () => {
    const newState = !open;
    setOpen(newState);
    sessionStorage.setItem(SIDEBAR_STORAGE_KEY, newState.toString());
  };

  const handleMenuClick = (route) => {
    sessionStorage.setItem(SIDEBAR_STORAGE_KEY, open.toString());
    navigate(route);
  };

  const handleMenuToggle = () => {
    const newState = !open;
    setOpen(newState);
    sessionStorage.setItem(SIDEBAR_STORAGE_KEY, newState.toString());
  };

  const logout = async () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = `${process.env.REACT_APP_SSO_LOGOUT_REDIRECT_URL}`;
  };

  const MenuItems = [
    {
      menu: "Email Compliance",
      route: "/email",
      icon: (
        <Mail className="colorCss" sx={{ fontSize: "20px" }} />
      ),
    },
    {
      menu: "Anonymizer",
      route: "/Anonymized",
      icon: <Shield className="colorCss" size={20} />
    },
    {
      menu: "AP Invoice",
      route: "/email-integrations",
      icon: <FileText className="colorCss" size={20} />
    },
    {
      menu: "Display Checker",
      route: "/retailDisplayChecker",
      icon: <Monitor className="colorCss" size={20} />
    }
  ];

  const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    background: bgColor,
    color: "#818181",
    overflowX: "hidden",
    borderRight: "1px dotted rgba(86,88,105, 1) !important",
    "&& .Mui-selected": {
      outline: "0px",
      border: "0px",
      cursor: "pointer",
      userSelect: "none",
      verticalAlign: "middle",
      appearance: "none",
      display: "flex",
      flexGrow: "1",
      justifyContent: "flex-start",
      alignItems: "center",
      textDecoration: "none",
      boxSizing: "border-box",
      textAlign: "left",
      transition: "background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      position: "relative",
      textTransform: "capitalize",
      color: "rgb(32, 101, 209);",
      borderRadius: "8px !important",
      backgroundColor: "#0000a0",
      fontWeight: "700 !important",
    },
    "&& .logoutLayout": {
      left: "20px !important",
      position: "Absolute",
      bottom: "20px",
    },
  });

  const closedMixin = (theme) => ({
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: bgColor,
    color: "white",
    overflowX: "hidden",
    borderRight: "1px dotted rgba(86,88,105, 1) !important",
    padding: "0px",
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up("sm")]: {
      width: `calc(${theme.spacing(8)} + 20px)`,
    },
    "&& .Mui-selected": {
      borderRadius: "8px !important",
    },
    "&& .logoutLayout": {
      left: "8px !important",
      position: "Absolute",
      bottom: "20px",
    },
    "&& .navHistory": {
      display: "none",
    },
  });

  const openbox = (theme) => ({
    left: "286px !important",
  });

  const closebox = (theme) => ({
    left: "72px !important",
  });

  const listTogglebox = (theme) => ({
    padding: "0 !important",
    paddingTop: "2rem !important",
    padding: "1rem .5rem 0rem !important",
    borderRadius: "20px",
  });

  const listTogglebox1 = (theme) => ({
    display: "none !important",
  });

  const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== "open",
  })(({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "noWrap",
    boxSizing: "border-box",
    ...(open && {
      ...openedMixin(theme),
      "& .MuiDrawer-paper": openedMixin(theme),
      "& .navButtonToggle": openbox(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      "& .MuiDrawer-paper": closedMixin(theme),
      "& .navButtonToggle": closebox(theme),
      "& .listToggle": listTogglebox(theme),
      "& .listToggle1": listTogglebox1(theme),
    }),
  }));

  return (
    <div>
      <div id="sidenavBarnew">
        <Box sx={{ display: "flex" }}>
          <Topnavbar
            setOpen={setOpen}
            open={open}
            toggleDrawer={toggleDrawer}
          />
          <Drawer
            className="sidenavBarstyle"
            variant="permanent"
            open={open}
          >
            {open && (
              <div
                style={{
                  position: "relative",
                  marginTop: "1.2rem",
                  justifyItems: "start",
                  display: "flex",
                  paddingLeft: "1rem",
                  paddingRight: "1rem",
                  justifyContent: "space-between",
                  alignContent: "center",
                  alignItems: "center",
                }}
              >
                <img src={aays} className="w-20 h-8" />
                <div onClick={handleMenuToggle}>
                  <MenuOpenIcon
                    sx={{ fontSize: "30px", cursor: "pointer", color: "#818181" }}
                  />
                </div>
              </div>
            )}

            {!open && (
              <div
                style={{
                  position: "relative",
                  marginTop: "0px",
                  height: "auto",
                }}
              >
                <div
                  style={{
                    paddingTop: "1.5rem",
                    marginTop: "0px",
                    paddingBottom: "1rem",
                    display: "grid",
                    justifyContent: "center",
                    justifyItems: "center",
                  }}
                >
                  <div onClick={handleMenuToggle}>
                    <MenuOpenIcon
                      sx={{
                        fontSize: "30px",
                        cursor: "pointer",
                        transform: "rotate(180deg)",
                        color: "#818181"
                      }}
                    />
                  </div>
                </div>
              </div>
            )}

            <List
              className="listToggle"
              style={{
                padding: "1.3rem",
                display: "grid",
                gridGap: "1rem",
                paddingTop: "3rem",
                alignContent: "baseline",
                alignItems: "baseline",
              }}
            >
              {MenuItems.map((menuItem, index) => (
                <ListItem
                  key={index}
                  className="itemsmenulist colorCss"
                  selected={menuItem.route === pathname}
                  disablePadding
                  sx={{ display: "block" }}
                  title={menuItem.menu}
                >
                  <ListItemButton
                    onClick={() => handleMenuClick(menuItem.route)}
                    sx={{
                      minHeight: 53,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 2 : "auto",
                        justifyContent: "center",
                        color: '#818181'
                      }}
                      className="colorCss"
                    >
                      {menuItem.icon}
                    </ListItemIcon>
                    <ListItemText
                      className="listToggle1"
                      primary={menuItem.menu}
                      sx={{ color: "#818181" }}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Drawer>

          <Dialog
            open={openDialog}
            onClose={() => setOpenDialog(!openDialog)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            id="logoutPopup"
          >
            <DialogTitle id="alert-dialog-title">
              {"Are you sure you want to logout?"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Please confirm your decision.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenDialog(!openDialog)}>No</Button>
              <Button onClick={logout}>Yes</Button>
            </DialogActions>
          </Dialog>
        </Box>
      </div>
    </div>
  );
};

export default SideNavbar;
